module.exports = __webpack_public_path__ + "img/playkids-logo-black.8e0e551e.svg";